export const DEFAULT_PAGE_SIZE: number = 50;
export const EMPTY_RESPONSE: unknown = {
  value: [],
  count: 0,
  page: 0,
  pageSize: 0,
  hasNextPage: false,
  hasPreviousPage: false,
};
